<ng-content select="[brainCatalogHeader]"></ng-content>

<!-- add filter -->
<ng-content select="[brainFilter]" *ngIf="!isLoading"></ng-content>

<div class="container mx-auto">
  <ng-container *ngIf="!isLoading">

    <!-- this is the search not a filter -->
    <brain-catalog-filter [products]="availableProducts" (filterChange)="onFilterChange($event)"></brain-catalog-filter>

    <ng-content></ng-content>
  </ng-container>
</div>
